<template>
  <div :class="['card-com', layout === 'horizontal' ? 'card-com-horizontal' : '']" @click="handleClick">
    <template v-if="layout === 'horizontal'">
      <div class="left-block"><slot name="left-block"></slot></div>
      <div class="right-block">
        <div class="title">
          <slot name="tit-icon"></slot>
          <div class="tit-text">{{ title }}</div>
        </div>
        <div class="desc">{{ desc }}</div>
        <div v-if="$slots.default" class="content"><slot></slot></div>
      </div>
    </template>
    <template v-else>
      <div class="title">
        <slot name="tit-icon"></slot>
        <div class="tit-text">{{ title }}</div>
      </div>
      <div class="desc">{{ desc }}</div>
      <div v-if="$slots.default" class="content"><slot></slot></div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    desc: {
      type: String,
      default: '',
    },
    layout: {
      type: String,
      default: 'vertical',
    },
  },
  methods: {
    handleClick() {
      this.$emit('click')
    },
  },
}
</script>

<style lang="less" scoped>
.card-com {
  padding: 40px;
}

.card-com-horizontal {
  display: flex;
  align-items: center;
}

.title {
  display: flex;
  align-items: center;

  .tit-text {
    font-size: 20px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    line-height: 28px;
  }
}

.desc {
  padding-top: 15px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  line-height: 20px;
}

.content {
  padding-top: 15px;
  a,
  .link {
    color: #cc0000;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    cursor: pointer;
  }
}
@media screen and (max-width: 768px) {
  .card-com {
    padding: 20px;
  }
  .title {
    .tit-text {
      font-size: 16px;
      line-height: 22px;
    }
  }
  .desc {
    padding-top: 10px;
  }
  .content {
    padding-top: 10px;
  }
}
</style>
